import httper from '../../common/httper.js'
import Qs from 'Qs'
const http = httper.create('/api')

export default {
  modifyPsw: (data) => http.post('/pc/sample/account/changPass', Qs.stringify(data)),
	sampledetaillist: (data) => http.get('/pc/sample/detail/list', {params: data}),//样本管理列表
	detailcheck: (data) => http.post('/pc/sample/detail/check', Qs.stringify(data)),//确认收样
	detailgetInfo: (data) => http.get('/pc/sample/detail/getInfo', {params: data}),//获取订单详情
	reportorderList: (data) => http.get('/pc/sample/report/orderList', {params: data}),//报告管理列表
	reportlist: (data) => http.get('/pc/sample/report/list', {params: data}),//报告管理列表——报告信息
	reportsave: (data,config) => http.post('/pc/sample/report/save', data, config),//上传报告
	reportdelete: (data) => http.post('/pc/sample/report/delete', Qs.stringify(data)),//删除报告
	reportwaitSend: (data) => http.get('/pc/sample/report/waitSend', {params: data}),//需寄送的报告列表
	reportconfirmSend: (data) => http.post('/pc/sample/report/confirmSend', Qs.stringify(data)),//确认报告寄出
	detailinvoiceList: (data) => http.get('/pc/sample/detail/invoiceList', {params: data}),//需开发票的基因检测列表
	detailwriteInvoice: (data) => http.post('/pc/sample/detail/writeInvoice', Qs.stringify(data)),//确认发票已开
	reportInterpretation: (data) => http.post('/pc/sample/report/reportInterpretation', Qs.stringify(data)),//
}



// WEBPACK FOOTER //
// ./src/services/index/api.js